export default __webpack_public_path__ + "static/media/logo-blue.329602a0.svg";